module.exports = __webpack_public_path__ + "static/media/T3-01.39ad55d8.svg";